module.exports = __webpack_public_path__ + "static/media/085.edd4be08.jpg";